import styles from "./NotificationBar.module.css";
import { Icon } from "@iconify/react";
import { Grid } from "@mui/material";

const NotificationBar = (props) => {
  return (
    <div className={`${styles.overallItems}`}>
      <div className={`${styles.Header}`}>
        <h5>{props.alert}</h5>
        <p>{props.AlertInfo}</p>
      </div>
      <div className={`${styles.AlertContent}`}>
        <Grid container spacing={2}>
          <Grid item lg={2} md={4} sm={6} xs={12}>
            <div>
              <p>User</p>
              <div className="flex gap-5 align-items-center">
                <Icon icon="gg:profile" width="20" height="20" />
                <h6>{props.SchName}</h6>
              </div>
            </div>
          </Grid>
          <Grid item lg={2} md={4} sm={6} xs={12}>
            <div>
              <p>Location</p>
              <div className="flex gap-5 align-items-center">
                <h6>{props.Location}</h6>
              </div>
            </div>
          </Grid>
          <Grid item lg={2} md={4} sm={6} xs={12}>
            <div>
              <p>Admin</p>
              <div className="flex gap-5 align-items-center">
                <h6>{props.AdminName}</h6>
              </div>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div>
              <p>Email</p>
              <div className="flex gap-5 align-items-center">
                <h6>{props.mail}</h6>
              </div>
            </div>
          </Grid>
          <Grid item lg={2} md={4} sm={6} xs={12}>
            <div>
              <p>Phone</p>
              <div className="flex gap-5 align-items-center">
                <h6>{props.Contact}</h6>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default NotificationBar;
